import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Database } from "lucide-react";
 * // Use <Database /> instead
 */
export const GraphQLIcon = createSVGWrapper(
  <>
    <path
      d="M12.5 3L4.5 7.5L4.5 16.5M12.5 3L20.5 7.5V16.5M12.5 3L4.5 16.5M12.5 3L20.5 16.5M4.5 16.5L12.5 21L20.5 16.5M4.5 16.5H20.5"
      stroke="currentColor"
    />
    <circle cx="12.5" cy="3" r="2" fill="currentColor" />
    <circle cx="12.5" cy="21" r="2" fill="currentColor" />
    <path
      d="M6.5 16.5C6.5 17.6046 5.60457 18.5 4.5 18.5C3.39543 18.5 2.5 17.6046 2.5 16.5C2.5 15.3954 3.39543 14.5 4.5 14.5C5.60457 14.5 6.5 15.3954 6.5 16.5Z"
      fill="currentColor"
    />
    <path
      d="M6.5 7.5C6.5 8.60457 5.60457 9.5 4.5 9.5C3.39543 9.5 2.5 8.60457 2.5 7.5C2.5 6.39543 3.39543 5.5 4.5 5.5C5.60457 5.5 6.5 6.39543 6.5 7.5Z"
      fill="currentColor"
    />
    <path
      d="M22.5 7.5C22.5 8.60457 21.6046 9.5 20.5 9.5C19.3954 9.5 18.5 8.60457 18.5 7.5C18.5 6.39543 19.3954 5.5 20.5 5.5C21.6046 5.5 22.5 6.39543 22.5 7.5Z"
      fill="currentColor"
    />
    <path
      d="M22.5 16.5C22.5 17.6046 21.6046 18.5 20.5 18.5C19.3954 18.5 18.5 17.6046 18.5 16.5C18.5 15.3954 19.3954 14.5 20.5 14.5C21.6046 14.5 22.5 15.3954 22.5 16.5Z"
      fill="currentColor"
    />
  </>
);
